import React, { useState } from 'react';
import PhoneInput, { type PhoneInputProps } from 'react-phone-input-2';
import styled from 'styled-components';
import 'react-phone-input-2/lib/material.css';

export type PhoneTextFiledProps = PhoneInputProps & {
  error?: boolean;
  helperText?: string;
};

export const PhoneTextFiled: React.FunctionComponent<PhoneTextFiledProps> = (
  props: PhoneTextFiledProps,
) => {
  const {
    error,
    helperText,
    inputStyle,
    containerStyle,
    disabled = false,
    ...rest
  } = props;
  const [isFocus, setIsFocus] = useState(false);
  const handleFocus = (): void => {
    setIsFocus(!isFocus);
  };

  return (
    <StyledPhoneTextFiled
      style={containerStyle}
      $error={error}
      $focus={isFocus}
      $disabled={disabled}
      aria-disabled={disabled}
      onFocus={handleFocus}
      onBlur={handleFocus}
    >
      <PhoneInput
        autoFormat={false}
        {...rest}
        disabled={disabled}
        inputStyle={
          inputStyle ?? {
            width: '100%',
            height: '56px',
            borderWidth: '1px',
            borderStyle: 'solid',
            ...(disabled ? { color: 'rgba(0, 0, 0, 0.38)' } : {}),
          }
        }
      />
      {error && (
        <div
          style={{ color: '#d32f2f', fontSize: '0.8rem', marginLeft: '1rem' }}
        >
          {helperText}
        </div>
      )}
    </StyledPhoneTextFiled>
  );
};

const StyledPhoneTextFiled = styled.div<{
  $error?: boolean;
  $focus: boolean;
  $disabled: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;

  input {
    border-color: ${props =>
      props.$disabled
        ? '#CACACA'
        : props.$error
          ? '#d32f2f'
          : props.$focus
            ? '#951D1D'
            : '#CACACA'} !important;
  }

  input: focus {
    outline: 1.4px solid
      ${props =>
        props.$disabled
          ? '#CACACA'
          : props.$error
            ? '#d32f2f'
            : props.$focus
              ? '#951D1D'
              : '#CACACA'} !important;
  }

  input: hover {
    cursor: ${props => (props.$disabled ? 'default' : '')} !important;
    border-color: ${props =>
      props.$disabled
        ? '#CACACA'
        : props.$error
          ? '#d32f2f'
          : props.$focus
            ? '#951D1D'
            : '#000000'} !important;
  }

  .special-label {
    font-size: 0.75rem !important;
    color: ${props =>
      props.$disabled
        ? 'rgba(0, 0, 0, 0.38)'
        : props.$error
          ? '#d32f2f'
          : props.$focus
            ? '#951D1D'
            : '#00000099'} !important;
  }
`;
